import React from 'react';

import { withLoadingAndNoConnectionHandler } from '../integration-wrapper';

import { LegalNoticeUi } from './ui';
import { useLegalNotice } from './useLegalNotice';

const LegalNoticeWithHandlers = withLoadingAndNoConnectionHandler(LegalNoticeUi);

export const LegalNotice: React.FC = () => {
    const { cmsContent: legalNotice, isLoading, loadingError } = useLegalNotice();

    return <LegalNoticeWithHandlers isLoading={isLoading} legalNotice={legalNotice} hasError={!!loadingError} />;
};
